import { Link } from "react-router-dom";
import "./Navbar.css";
import CustomLink from "./CustomLink";
import { AdminNavbar } from "./AdminNavbar";
import DosenNavbar from "./DosenNavbar";
import Auth from "@services/Auth/Auth";
import ROLES from "../../../../utils/constants/roles.constants";
import { userRoleIs } from "../../../../utils/helpers/roles.helpers";
import UserDropdown from "./UserDropdown";
import { StaffNavbar } from "./StaffNavbar";
import { ManajerNavbar } from "./ManajerNavbar";
import MahasiswaNavbar from "./MahasiswaNavbar";

function Navbar() {
  const user = Auth.getCurrentUser();
  return (
    <div className="fixed z-40 flex flex-col items-center content-center bg-white w-full py-2 md:py-4 top-0 left-0 border-b border-gray-200">
      <div className="flex overflow-x-auto flex-wrap items-center justify-between max-w-7xl w-full px-4">
        <Link to="/" className="flex items-center pb-2 xl:pb-0">
          <span className="self-center text-xl font-semibold whitespace-nowrap">
            Sistem Informasi Penjadwalan Sidang{" "}
            {process.env.REACT_APP_ENV != "PRODUCTION" && (
              <sup className="text-xs font-thin italic">
                {process.env.REACT_APP_ENV}
              </sup>
            )}
          </span>
        </Link>
        <div className="w-full md:w-auto" id="navbar-default">
          <ul className="flex flex-row items-center gap-6 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-100 border-0">
            <div itemkey="sisidang-lama">
              <a
                href="https://sidang-lama.cs.ui.ac.id"
                target="_blank"
                rel="noreferrer"
                className="block py-2 pr-4 pl-3 hover:text-blue-700 rounded md:bg-transparent md:p-0"
              >
                SISIDANG lama
              </a>
            </div>
            {user != null && (
              <CustomLink
                itemkey="petunjuk_penggunaan"
                to="/petunjuk-penggunaan"
              >
                <span className="block py-2 pr-4 pl-3 hover:text-blue-700 rounded md:bg-transparent md:p-0">
                  Petunjuk Penggunaan
                </span>
              </CustomLink>
            )}
            <CustomLink itemkey="beranda" to="/">
              <span className="block py-2 pr-4 pl-3 hover:text-blue-700 rounded md:bg-transparent md:p-0">
                Beranda
              </span>
            </CustomLink>
            {user != null &&
              (userRoleIs(user, ROLES.ADMIN) ||
                userRoleIs(user, ROLES.DEVELOPER)) && <AdminNavbar />}
            {user != null && userRoleIs(user, ROLES.MANAJER) && (
              <ManajerNavbar />
            )}
            {user != null && userRoleIs(user, ROLES.STAFF) && <StaffNavbar />}
            {user != null &&
              (userRoleIs(user, ROLES.DOSEN) ||
                userRoleIs(user, ROLES.DEVELOPER)) && <DosenNavbar />}
            {user != null &&
              (userRoleIs(user, ROLES.MAHASISWA) ||
                userRoleIs(user, ROLES.DEVELOPER)) && <MahasiswaNavbar />}
            {user == null && (
              <CustomLink itemkey="login" to="/masuk">
                <div className="button-primary">
                  <button className="flex gap-1 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex inline-block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>Masuk</span>
                  </button>
                </div>
              </CustomLink>
            )}
            {user != null && (
              <>
                <li key={"user-menu"} className="flex items-center">
                  <UserDropdown />
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
